import React from "react";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import PageHeader from "../../shared/components/PageHeader";

const termLabel = (term) =>
  term ? `${term.name}${term.is_semester_term ? " (semester)" : ""}` : "";

// Compact chip styling for the term select beside the title: no fixed width (it
// sizes to the selected term), tighter padding/font than size="small", and the
// arrow pulled to the edge with the right padding set to just clear it.
const compactSelectSx = {
  flexShrink: 0,
  fontSize: 13,
  "& .MuiSelect-select": { py: 0.5, pl: 1, pr: "22px" },
  "& .MuiSelect-icon": { right: 0 },
};

// Page-header definition for the legacy v1 Classes page. Only the title and the
// term selector move into the v2 header; the class counters, the show-all/my
// toggle, and the "Manage order" controls stay in the legacy body. v1 owns the
// term list and the `term` param the class fetch keys off, and hands them across
// the bridge as data + an onTermChange callback.
export default function ClassesHeader({
  terms = [],
  selectedTermId,
  onTermChange,
}) {
  // Clamp to a value one of the rendered MenuItems actually carries; terms can be
  // empty on first paint while v1 fetches them, and an unmatched value trips
  // MUI's out-of-range warning.
  const value = terms.some((t) => t.id === selectedTermId)
    ? selectedTermId
    : "";

  return (
    <PageHeader
      title={
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}
        >
          <Typography
            sx={{ fontSize: 24, lineHeight: 1.2, whiteSpace: "nowrap" }}
          >
            Classes
          </Typography>
          {/* No floating InputLabel: the header sits flush to the navbar, so a
              label animating up would clip behind it. An inline placeholder
              (displayEmpty + renderValue) keeps the control compact instead. */}
          <Select
            size="small"
            value={value}
            onChange={(e) => onTermChange(e.target.value)}
            displayEmpty
            inputProps={{ "aria-label": "Term" }}
            renderValue={(v) =>
              termLabel(terms.find((t) => t.id === v)) || "Select term"
            }
            sx={compactSelectSx}
          >
            {terms.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {termLabel(t)}
              </MenuItem>
            ))}
          </Select>
        </Box>
      }
    />
  );
}
